import * as React from "react";

import { LoginAppProvider, LOGIN_FORM_WINDOW_EVENTS } from "../../../Common";

export const ReactWishlistGuestLoginAppProvider: React.FunctionComponent = (
  props
) => {
  const handleLoginSuccess = React.useCallback(() => {
    window.location.reload();
  }, []);
  React.useEffect(() => {
    window.addEventListener(
      LOGIN_FORM_WINDOW_EVENTS.LOGIN_SUCCESS,
      handleLoginSuccess
    );
    return () => {
      window.removeEventListener(
        LOGIN_FORM_WINDOW_EVENTS.LOGIN_SUCCESS,
        handleLoginSuccess
      );
    };
  }, [handleLoginSuccess]);
  return (
    <LoginAppProvider
      shouldLoginUsingTheSpecialAsynchronousApiInsteadOfFormPost
      shouldContinueLoadingAfterLoginSuccess
    >
      {props.children || []}
    </LoginAppProvider>
  );
};
